import { render, staticRenderFns } from "./AdminClimateZoneList.vue?vue&type=template&id=3adeabe6&"
import script from "./AdminClimateZoneList.vue?vue&type=script&lang=js&"
export * from "./AdminClimateZoneList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports